<template>
  <div class="header">
    <el-row>
      <el-col :span="24">
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-submenu index="1">
            <template slot="title">openapi</template>
            <el-menu-item index="2-1">
              <el-link href="#/openapi?method=openapi.singleitem.synchronize&type=openapi">接口文档</el-link>
            </el-menu-item>
            <el-menu-item index="2-1">
              <el-link href="#/openapi/debug?method=openapi.singleitem.synchronize&type=openapi">API测试工具</el-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="">
            <template slot="title">{{ $t("message.selectLan") }}</template>
            <el-menu-item index="3-1">
              <el-link @click="changeLan('en')">English</el-link>
            </el-menu-item>
            <el-menu-item index="3-2">
              <el-link @click="changeLan('cn')">简体中文</el-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  created () {
    let lang = localStorage.getItem('lang')
    if (lang) {
      this.$i18n.locale = lang
    }
  },
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    changeLan(val) {
      this.$i18n.locale = val
      localStorage.setItem('lang', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue